<template lang='pug'>
  .fpui-input-number
    input(
      :placeholder="placeholder | translate"
      type="number"
      v-model='model'
      :class="className"
      :disabled="disabled"
      @click="$emit('click', $event)"
    )
</template>

<script>

export default {
  props: {
    value: { type: [String, Number], required: true, default: '' },
    color: { type: String, default: 'blue' },
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    placeholder: { type: String }
  },
  computed: {
    model: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    },
    className () {
      let className = [`fpui-input-color-${this.color}`]
      if (this.disabled) className.push('disabled')
      if (this.error) className.push('error')
      return className.join(' ')
    }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";

.fpui-input-number {
  position:relative;
  input {
    width: 100%;
    border-radius: 2px;
    background: #FFF none repeat scroll 0% 0%;
    padding: 8px;
    border: 1px solid @grey;
    font-size: 1em;
    font-weight: 300;
    letter-spacing: 1px;
    outline: none;
    &:disabled {
      background: #eee;
    }
    .input-transition();
    &.fpui-input-color-blue:not(.error):focus {
      border-color: @blue;
    }
    &.fpui-input-color-green:not(.error):focus {
      border-color: @green;
    }
    &.fpui-input-color-red:focus, &.error {
      border-color: @red;
    }
    &.fpui-input-color-yellow:not(.error):focus {
      border-color: @yellow;
    }
  }
}
</style>
